/* eslint-disable no-useless-escape */
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
// Crypto Redux States
import { PermissionsTypes } from './actionTypes';
import {
  getPermissionsSuccess,
  getPermissionsFail,
  addPermissionsFail,
  addPermissionsSuccess,
  deletePermissionsSuccess,
  deletePermissionsFail,
  updatePermissionsFail,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';

export const fetchPermissions = async (data: any) => {
  const { sizePerPage, page } = data?.pagination ?? {
    sizePerPage: 50,
    page: 1,
  };

  /* let textClient = '';
  let textName = '';

  if (data.data) {
    textClient = data.data['Search Client ID'];
    textName = data.data['Search Name'];
  } */
  /* Pagination:{
    sizePage:${sizePerPage},
    actualPage:${page},
  }, */

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }


  const query = `query {
    permisosList (
    FilterEmpresaID:{userId:${user.id}},
    order : "${data.order}",   

    ) {
      permisosData {
      id
      nombre
      version
      descripcion
      url_menu
      icon
      MCA_ACTIVO
      EMPRESA_ID
      IDIOMA_ID
      applicationId
      orden
      createdAt
      updatedAt
      padreId    
      identificator
      URL
      holisticsClientIdentificator
      clientSecret
      code
      generic
      excludedClientIds
      excludedRoles
      JSONHollistics
      permisoGUID
      },
    CountItems
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.permisosList;
};

function* getPermissionsSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchPermissions, data.payload);
    yield put(getPermissionsSuccess(response));
  } catch (error) {
    yield put(getPermissionsFail(error));
  }
}

export const addPermissionsList = async ({
  payload: { permissionsAdd },
}: any) => {
  const path = url.API_URL;
  const {
    nombre,
    descripcion,
    url_menu,
    icon,
    IDIOMA_ID,
    orden,
    MCA_ACTIVO,
    EMPRESA_ID,
    padreId,
    identificator,
    URL,
    holisticsClientIdentificator,
    clientSecret,
    code,
    generic,
    excludedClientIds,
    excludedRoles,
    JSONHollistics
  } = permissionsAdd.permission;

  const query = `mutation {  
    createPermiso(Permiso:  {
      nombre: "${nombre}",
      descripcion:"${descripcion}",
      url_menu:"${url_menu}",
      MCA_ACTIVO:${MCA_ACTIVO},
      icon:"${icon}",
      IDIOMA_ID:${IDIOMA_ID === "" ? 0 : IDIOMA_ID},
      padreId:"${padreId}",
      orden:${orden === "" ? 1 : orden},
      EMPRESA_ID:"${JSON.stringify(EMPRESA_ID)}",
      identificator:"${identificator}",
      URL:"${URL}",
      holisticsClientIdentificator:"${holisticsClientIdentificator}",
      clientSecret:"${clientSecret}",
      code:${code ? JSON.stringify(code.replace(/\"/g, "'")) : null},
      generic:${generic},
      excludedClientIds:"${JSON.stringify(excludedClientIds)}",
      excludedRoles:"${JSON.stringify(excludedRoles)}",
      JSONHollistics:${JSONHollistics ? JSON.stringify(JSONHollistics.replace(/\"/g, "'")) : null},
    }){
      nombre
      }
  }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query
    }),
  }).then((res) => res.json());

  return respon.data.createPermiso;
};

function* addPermissionsSaga(permission: any) {
  const { pagination } = permission.payload.permissionsAdd;

  try {
    const response: Promise<any> = yield call(addPermissionsList, permission);
    yield put(addPermissionsSuccess(response));

    const response2: Promise<any> = yield call(fetchPermissions, {
      pagination,
    });
    yield put(getPermissionsSuccess(response2));
  } catch (error) {
    yield put(addPermissionsFail(error));
  }
}

export const deletePermissionsList = async (id: any) => {
  const path = url.API_URL;
  const query = `mutation{
    deletePermiso(Permiso: {
      id: "${JSON.stringify(id)}"
     })
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deletePermiso;
};

function* deletePermissionsSaga({ payload }: any) {
  const { id, pagination } = payload;
  try {
    const response: Promise<any> = yield call(deletePermissionsList, id);
    yield put(deletePermissionsSuccess(response));
    const response2: Promise<any> = yield call(fetchPermissions, {
      pagination,
    });
    yield put(getPermissionsSuccess(response2));
  } catch (error) {
    yield put(deletePermissionsFail(error));
  }
}

function* updatePermissionsList(action: any): any {
  const { payload } = action;
  const { pagination } = payload.permissions;
  const path = url.API_URL;
  const {
    id,
    nombre,
    descripcion,
    url_menu,
    MCA_ACTIVO,
    EMPRESA_ID,
    IDIOMA_ID,
    orden,
    icon,
    padreId,
    identificator,
    URL,
    holisticsClientIdentificator,
    clientSecret,
    code,
    generic,
    excludedClientIds,
    permisoGUID,
    excludedRoles,
    JSONHollistics
  } = payload.permissions.permission;

  let newExcludedClientIds = excludedClientIds
  let newExcludedRoles = excludedRoles

  if (typeof excludedClientIds !== "string") {
    newExcludedClientIds = JSON.stringify(excludedClientIds)
  }
  if (typeof excludedRoles !== "string") {
    newExcludedRoles = JSON.stringify(excludedRoles)
  }

  let padreIddos = padreId;
  if (padreId === 0 || padreId === "0" || padreId === "" || padreId === null) {
    padreIddos = null;
  }
  const query = `mutation {
    updatePermiso(Permiso:  {
      id: "${JSON.stringify(id)}"
      nombre: "${nombre}",
      descripcion:"${descripcion}",
      url_menu:"${url_menu}",
      MCA_ACTIVO:${MCA_ACTIVO},
      icon:"${icon}",
      EMPRESA_ID:"${JSON.stringify(EMPRESA_ID)}",
      IDIOMA_ID:${IDIOMA_ID === "" ? 0 : IDIOMA_ID},
      orden:${orden === "" ? 1 : orden},
      padreId:"${padreIddos}",
      identificator:"${identificator}",
      URL:"${URL}",
      holisticsClientIdentificator:"${holisticsClientIdentificator}",
      clientSecret:"${clientSecret}",
      code:${code ? JSON.stringify(code?.replace(/\"/g, "'")) : null},
      generic:${generic},
      excludedClientIds:"${newExcludedClientIds}",
      excludedRoles:"${newExcludedRoles}",
      JSONHollistics:${JSONHollistics ? JSON.stringify(JSONHollistics?.replace(/\"/g, "'")) : null},
      permisoGUID:"${permisoGUID}",
    }){
      nombre
      }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);
    yield new Promise(resolve => setTimeout(resolve, 1000));
    const response: Promise<any> = yield call(fetchPermissions, { pagination });
    yield put(getPermissionsSuccess(response));
  } catch (error) {
    yield put(updatePermissionsFail(error));
  }
}

function* PermissionsSaga() {
  yield takeEvery(PermissionsTypes.GET_PERMISSIONS, getPermissionsSaga);
  yield takeEvery(PermissionsTypes.ADD_PERMISSIONS, addPermissionsSaga);
  yield takeEvery(PermissionsTypes.DELETE_PERMISSIONS, deletePermissionsSaga);
  yield takeLatest(PermissionsTypes.UPDATE_PERMISSIONS, updatePermissionsList);
}

export default PermissionsSaga;
